import { Colors } from "@kamstrup/kfl";

export const commonStyles = {
  introText: {
    margin: "20px 0",
    lineHeight: 1.5,
    color: "#7F7F7F"
  },
  linkText: {
    color: "primary.main",
    cursor: "pointer"
  },
  buttonContainer: {
    width: "100%",
    paddingBottom: "10px"
  },
  button: {
    height: "48px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 16px",
    textTransform: "none",
    fontSize: "16px"
  },
  textFieldContainer: {
    margin: "24px 0 24px 0",
    width: "100%"
  },
  infoBox: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#E6F5FC",
    padding: "12px",
    marginBottom: "24px"
  },
  infoText: {
    lineHeight: 1.5,
    fontSize: "14px",
    color: "#212121"
  },
  iconContainer: {
    width: "22px",
    height: "22px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "12px"
  },
  divider: {
    position: "relative",
    height: "2px",
    width: "100%",
    backgroundColor: Colors.GREY_12,
    borderRadius: "4px",
    overflow: "hidden",
    margin: "12px 0 12px 0"
  },
  autoComplete: {
    margin: 0,
    "& .MuiInputLabel-root": {
      top: "8px"
    },
    "& .MuiInputLabel-shrink": {
      top: "0px"
    },
    "& .MuiOutlinedInput-root": {
      height: "48px",
      boxSizing: "border-box"
    },
    "& .MuiOutlinedInput-input": {
      padding: "12px 14px"
    }
  },
  cancelButtonContainer: {
    display: "flex",
    justifyContent: "center"
  }
};
